import React, { useState, useEffect } from "react"

import Header from "../../components/Header"
import NavigationButtons from "../../components/NavigationButtons"
import Input from "../../components/Input/Input"

import styles from "../../css/Page.module.css"

const NewSubscription = props => {

  return (
    <div>
      <Header title="Vad för abonnemang skall numret läggas på?" />
      <div className={styles.inputContainer}>
        <Input
          name="newSubscriptionChoice"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
        />
        <Input
          name="vacantNumber"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
          hide={props.inputState.newSubscriptionChoice.value != 'vacant'}
        />
      </div>
      {/*<NavigationButtons
        inputState={props.inputState}
  />*/}
    </div>
  )
}
  
export default NewSubscription